module.exports = __webpack_public_path__ + "static/media/jm.2fbfcbf1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/jm.svg
// module id = 854
// module chunks = 0